export default __webpack_public_path__ + "static/media/cherie-du-avatar-small.aa7fbafd.jpg";